import React from 'react';
import { Field } from 'formik';
import { useIntl, defineMessages } from 'react-intl';
import {
  InputTextComponent,
  TextAreaComponent,
} from '../../../components/prime-formik';

const i18nMessages = defineMessages({
  surveyItemCode: {
    id: 'menu.item-bank-management.survey-item-code',
    defaultMessage: 'Survey Item Code',
  },
  surveyItemText: {
    id: 'menu.item-bank-management.survey-item-text',
    defaultMessage: 'Survey Item Text',
  },
  surveyItemSelfText: {
    id: 'menu.item-bank-management.survey-item-self-text',
    defaultMessage: 'Survey Item Self Text',
  },
});

const AddSurveyItem = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="behavior-item-details-controls">
      <div>
        <div className="input-label">{formatMessage(i18nMessages.surveyItemCode)}</div>
        <div>
          <Field
            id="code"
            name="code"
            component={InputTextComponent}
          />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.surveyItemText)}</div>
        <div>
          <Field
            id="text"
            name="text"
            component={TextAreaComponent}
          />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.surveyItemSelfText)}</div>
        <div>
          <Field
            id="selfText"
            name="selfText"
            component={TextAreaComponent}
          />
        </div>
      </div>
    </div>
  );
};

export default AddSurveyItem;
